module.exports = __webpack_public_path__ + "img/hz5.44ca16f2.png";